module.exports = function() {
  return new Worker(__webpack_public_path__ + "fdc7ebcebf2332fe7842.worker.js");
};